(function() {
    'use strict';

    angular.module( APP_ID )
        .directive( 'uiSelect', [ '$timeout', UiSelectDirective ] );


    /**
     * Turns a standard angular <select> element into the custom one with use of
     * 'select2' 3rd party plugin (see https://github.com/select2/select2).
     *
     * @type {ng.IDirectiveCompileFn}
     */
    function UiSelectDirective( $timeout ){


        /** @type {ng.IDirective} */
        var directiveConfig = {
            scope:       {},
            restrict:    'A',
            link:        link
        };



        ////////////////////////////////////////////////////////////////////////

        return directiveConfig;

        ////////////////////////////////////////////////////////////////////////



        /**
         * @param {ng.IScope} $scope
         * @param {ng.IElement} $element
         */
        function link( $scope, $element ) {





            /* ===== RUN ON INSTANTIATION =================================== */


            /** @constructor */
            (function init(){
                $timeout( function() {
                    if ( $scope.$parent.vm && $scope.$parent.vm.selectConfig ) {
                        // Format: https://select2.github.io/options.html
                        $element.select2( $scope.$parent.vm.selectConfig ); // Attach ui-select 2
                    } else {
                        $element.select2();
                    }
                }, 0 );

            })();


        }


    }
})();
